
// 导航遮罩效果
const overlay = document.createElement('div');
overlay.style.cssText = `
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
`;
document.body.appendChild(overlay);

let hideTimer = null;

document.querySelectorAll('.menu-list__list-item').forEach(item => {
  item.addEventListener('pointerenter', () => {
    clearTimeout(hideTimer);
    overlay.style.opacity = '1';
  });

  item.addEventListener('pointerleave', () => {
    hideTimer = setTimeout(() => {
      overlay.style.opacity = '0';
    }, 100);
  });
});

document.querySelectorAll('.menu-list__submenu').forEach(submenu => {
  submenu.addEventListener('pointerenter', () => {
    clearTimeout(hideTimer);
    overlay.style.opacity = '1';
  });

  submenu.addEventListener('pointerleave', () => {
    hideTimer = setTimeout(() => {
      overlay.style.opacity = '0';
    }, 100);
  });
});